export default __webpack_public_path__ + "static/media/download.7377bdb3.svg";